import { render, staticRenderFns } from "./TaskCenterStatics.vue?vue&type=template&id=2e0cd967&scoped=true"
import script from "./TaskCenterStatics.vue?vue&type=script&lang=js"
export * from "./TaskCenterStatics.vue?vue&type=script&lang=js"
import style0 from "./TaskCenterStatics.vue?vue&type=style&index=0&id=2e0cd967&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0cd967",
  null
  
)

export default component.exports